import React from 'react';
import styled from 'styled-components';

type Props = {
  value: string | number;
  mask: string;
  onChange: (value: string) => any;
  isOnFocus: boolean;
  onBlur: (value: string) => any;
};

export type InputRef = HTMLInputElement;

function RangeInput(
  { value, mask, onChange, isOnFocus, onBlur }: Props,
  ref: React.Ref<InputRef>
) {
  return (
    <>
      <Mask>{mask} </Mask>{' '}
      <Input
        autoFocus={isOnFocus}
        ref={ref}
        type="text"
        value={value}
        onChange={(event) => onChange(event.target.value)}
        onBlur={(event) => {
          onBlur(event.target.value);
        }}
      />
    </>
  );
}

export default React.forwardRef<InputRef, Props>(RangeInput);

const Mask = styled.div`
  position: absolute;
  left: 15px;
  top: 50%;
  transform: translateY(-50%);
`;

const Input = styled.input`
  padding-left: 45px;
  height: 100%;
  width: 100%;
  outline: none;
  border: none;
`;
